import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'PVT' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'PVT', label: 'Price Volume Trend', pane: 'sub', params: [], outputs: ['pvt'], tailSafe: false })
